import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

class CoursEnfant extends Component {
state = {
    redirect:false,
    search: ''
    }

handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
}

setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

render () {  
    return (
    <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <div className="contact-content">
                        <h1><span>Cours pour enfants - PRINTEMPS 2020</span></h1>   
                          <p><strong>Date du début: </strong>19 septembre<br />
                          <strong>Prè-inscriptions en ligne: </strong>8 septembre<br />
                          <strong>Inscription pour tous: </strong>10 septembre<br /></p>
                        <p>
                        Attention: afin de respecter les normes de la croix rouge concernant la crise du Covid-19,
                        les moniteurs NE SONT pas autorisés à avoir des contacts avec les enfants. LA PRÉSENCE d'un parent DANS l'eau est obligatoire pour les groupes suivant:<br /></p>
                        <p>
                        <i>Etoile de mer</i><br />
                        <i>Canard</i><br />
                        <i>Tortue de mer</i><br />
                        <i>Loutre</i><br />
                        <i>Salamandre</i><br />
                        <i>Poisson-lune</i><br />
                        <i>Junior 1</i><br />
                        <i>Junior 2</i><br />
                       </p>


                        <p>Pour plus d'informations concernant le niveau de votre enfant, vous pouvez consulter le détail des cours Croix Rouge<br /></p>
                       <Col lg={12} md={12} sm={12} xs={12} className="nopadding link-emploi">
                          <a href="https://www.croixrouge.ca/cours-et-certificats/description-de-cours/cours-de-natation-et-de-securite-aquatique/cours-de-natation"
                           className="btn btn-primary btn-blue-light emploi">
                          TOUTES LES INFORMATIONS ICI
                          </a>
                        </Col>
                       
                    </div>

                    </Col>
                    </Row>
                </Col>


            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <div className="fixed-bottom-footer"><Footer /></div>
            </Col>
            </Col>
        </Row>
        </Container>
    </>
    )
}
}

export default CoursEnfant
